import string from 'common/helpers/primitives/string'


const getTruncatedText = (text: string, length: number) => {
  let result = string.multiLineToOneLine(text)
  // Trim to length wihtout breaking words apart
  result = result.replace(new RegExp(`^(.{${length}}[\\S]*).*`), '$1')
  // Add dots symbol
  result = `${result}…`

  return result
}


export default getTruncatedText
